import react, {useEffect, useState} from 'react'
import {ArrowIcon} from '../icons'
import './style.css'
import {logEvent, useUser} from "utils";
import {useAuth} from "hooks/useAuth";
import {observer} from "mobx-react-lite";

export const Avatar: react.FC<{sidebarOpen: boolean}> = observer(({sidebarOpen}) => {
    const [active, setActive] = useState(false);
    const [account, setAccount] = useState(() => localStorage.getItem("itsai_user_id"));
    const {logout, authenticated} = useAuth();
    const user = useUser()
    const username = user?.username

    useEffect(() => {
        if (username) {
            setAccount(username);
        }
    }, [username]);

    if (!account) {
        return <></>
    }

    return <div className={'avatar__container ' + (active ? "avatar-active__container" : "") + (sidebarOpen ? "" : " avatar__container__closed")} onClick={() => {
        setActive(!active);
    }}>
        <div className={"avatar__menu " + (active ? "avatar-menu__active" : "")}>
            <span className='avatar-menu__item red' onClick={() => {
                setActive(false);
                logEvent("user__logout").finally(() => {
                    localStorage.removeItem('token')
                    const url = new URL(window.location.href);
                    url.searchParams.delete('token');

                    if (authenticated) {
                        logout().then((e) => {
                            window.location.assign(url.toString())
                        });
                    } else {
                        window.location.assign(url.toString())
                    }
                })

            }}>Log out</span>
        </div>
        <div className="avatar">{account.slice(0,2)}</div>
        {
            sidebarOpen ?
                <div className="avatar__content">
                    <div className="avatar__name">{account.slice(0, 15) + (account.length > 15 ? '...' : '')}</div>
                    <div className="checked">
                        <ArrowIcon />
                    </div>
                </div>
            : <></>
        }

    </div>
})